import type React from "react";
import { TableContainer, Paper, Box, CircularProgress } from "@mui/material";

interface StyledTableProps {
  children: React.ReactNode;
  loading?: boolean;
  emptyMessage?: string;
  testId?: string;
}

const StyledTable: React.FC<StyledTableProps> = ({
  children,
  loading = false,
  emptyMessage,
  testId,
}) => {
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      data-testid={testId}
      sx={{
        boxShadow: "none",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        width: "100%",
        "& .MuiPaper-root": {
          backgroundColor: "transparent",
        },
        "& .MuiTableCell-root": {
          paddingTop: (theme) => theme.density.tableCellPaddingY,
          paddingBottom: (theme) => theme.density.tableCellPaddingY,
        },
        "& .MuiTableCell-head": {
          paddingTop: (theme) => theme.density.tableHeadPaddingY,
          paddingBottom: (theme) => theme.density.tableHeadPaddingY,
        },
        "& .MuiTableRow-root:not(.MuiTableRow-head):hover": {
          backgroundColor: (theme) => `${theme.palette.action.hover} !important`,
          cursor: "pointer",
          "& .MuiTableCell-root": {
            backgroundColor: "inherit !important",
          },
        },
      }}
    >
      {children}
    </TableContainer>
  );
};

export default StyledTable;
